'use strict';

var _ = require('lodash');
var PooledSeasonalityIndexAnalysisDataRetrieverService = function PooledSeasonalityIndexAnalysisDataRetrieverService($q, pooledReviewCalendarService, seasonalityReviewConstants, chartHelper, dataTransformationService) {
  var defaultDemandData = {
    actual: 0,
    scale: 0
  };
  function getIndexChartData(flowType, calendarData, filterData) {
    var indexProfileType = chartHelper.getProfileName(flowType, seasonalityReviewConstants.PROFILE_TYPE.INDEX);
    var market = calendarData.market.split('-');
    return $q.all([retrieveProfiles(indexProfileType, filterData, market, calendarData, filterData.selectedRtp), retrieveDemandProfiles(flowType, filterData, market, calendarData)]);
  }
  function retrieveProfiles(profileType, filterData, market, calendarData, rtps) {
    var usableDow = pooledReviewCalendarService.getUsableDowGroup(filterData.selectedDow);
    var calendarName;
    var filters = {
      origin: market[0],
      destination: market[1],
      significantPOS: filterData.significantPOS,
      cabin: filterData.selectedCabin,
      dowGroup: usableDow
    };
    var localFilter = [{
      attribute: 'attributes.daysToDeparture',
      filter: rtps
    }];
    if (chartHelper.isProfileInactiveOrPublishing(calendarData)) {
      calendarName = calendarData.calendarName;
    } else {
      filters.scenarioName = chartHelper.getScenarioName(calendarData);
    }
    return pooledReviewCalendarService.fetchHepProfiles(profileType, filters, localFilter, calendarName);
  }
  function retrieveDemandProfiles(flowType, filterData, market, calendarData) {
    var usableDow = pooledReviewCalendarService.getUsableDowGroup(filterData.selectedDow);
    var demandProfileType = chartHelper.getProfileName(flowType, seasonalityReviewConstants.PROFILE_TYPE.DEMAND);
    var calendarName;
    var filters = {
      origin: market[0],
      destination: market[1],
      significantPOS: filterData.significantPOS,
      dayOfWeekGroup: usableDow
    };
    var localFilter = [{
      attribute: 'attributes.classSetId',
      filter: [filterData.selectedClassGroup]
    }];
    if (chartHelper.isProfileInactiveOrPublishing(calendarData)) {
      calendarName = calendarData.calendarName;
    } else {
      filters.scenarioName = chartHelper.getScenarioName(calendarData);
    }
    return pooledReviewCalendarService.fetchHepProfiles(demandProfileType, filters, localFilter, calendarName);
  }
  function transformData(profiles, selectedRtp) {
    var indexProfiles = profiles[0];
    var demandProfiles = profiles[1];
    var averageDemandMap = {};
    if (_.isArray(demandProfiles) && demandProfiles.length > 0) {
      averageDemandMap = dataTransformationService.computeAverageDemand(demandProfiles[0], selectedRtp);
    }
    return _.chain(indexProfiles).reduce(function (chartData, currentProfile) {
      var rtp = currentProfile.attributes.daysToDeparture;
      return chartData.concat({
        rtp: rtp,
        woyIndices: dataTransformationService.getScaledWoyIndices(currentProfile),
        averageDemand: _.get(averageDemandMap, rtp, defaultDemandData)
      });
    }, []).sortBy(function (row) {
      return parseInt(row.rtp);
    }).value();
  }
  return {
    getIndexChartData: getIndexChartData,
    transformData: transformData
  };
};
PooledSeasonalityIndexAnalysisDataRetrieverService.$inject = ['$q', 'PooledReviewCalendarService', 'PooledSeasonalityReviewConstants', 'PooledSeasonalityChartsHelper', 'PooledSeasonalityChartDataTransformationService'];
module.exports = PooledSeasonalityIndexAnalysisDataRetrieverService;